import React from 'react';
import { Application } from '../../../../../../../../entities/Application';
import { AlertObject } from '../../../../../../../../components/Alert';
import { IconButton } from '../../../../../../../../components/IconButton';
import { NoteModal } from '../../../../../../../../components/ApplicantTracking/NoteModal';
import { useApplicationNoteModal } from '../../useApplicationNoteModal';

interface PropTypes {
  application: Application;
  setAlert: (alert: AlertObject) => void;
  onNoteAdded: () => void;
}

export function AddNoteModal(props: PropTypes) {
  const { isNoteModalOpen, openNoteModal, closeNoteModal, submitNote } =
    useApplicationNoteModal(props);

  return (
    <>
      <NoteModal
        mode='Add'
        onSubmit={submitNote}
        isOpen={isNoteModalOpen}
        disableAlerts={true}
        onClose={closeNoteModal}
      />
      <IconButton
        iconName='bi-file-earmark-text'
        buttonText='Add Note'
        buttonClass='p-0 text-decoration-none fs-5'
        color='link'
        iconClass='text-info'
        textClass='text-info'
        onClick={openNoteModal}
      />
    </>
  );
}
